define("Bazaarvoice.PLP.InlineRatings.View", [
  "SCView",
  "bazaarvoice_plp_inline_ratings.tpl",
  "underscore",
], function (SCViewComponent, bazaarvoice_plp_inline_ratings_tpl, _) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function BazaarvoicePLPInlineRatingsView(options) {
    SCView.call(this);

    this.options = options || {};
    this.contextDataRequest = ["item"];
    this.container = this.options.container;
    this.template = bazaarvoice_plp_inline_ratings_tpl;
  }

  BazaarvoicePLPInlineRatingsView.prototype = Object.create(SCView.prototype);

  BazaarvoicePLPInlineRatingsView.prototype.constructor =
    BazaarvoicePLPInlineRatingsView;

  BazaarvoicePLPInlineRatingsView.prototype.getItem = function () {
    if (!this.contextData || !_.isFunction(this.contextData.item)) {
      return {};
    }

    return this.contextData.item();
  };

  BazaarvoicePLPInlineRatingsView.prototype.getContext = function () {
    var item = this.getItem();

    return {
      productId: item.itemid,
      productUrl: window.location.origin + item.keyMapping_url,
    };
  };

  return BazaarvoicePLPInlineRatingsView;
});
